import { gql } from "graphql-tag";
import React, { useEffect, useState } from "react";
import LinkButton from "src/components/buttons/LinkButton";
import CustomerInfoRequestResponses from "src/components/checkout/CustomerInfoRequestResponses";
import { useForm } from "src/components/forms/Form";
import ClassModel from "src/models/ClassModel";
import GroupRegistrationModel from "src/models/GroupRegistrationModel";
import { apiClient } from "src/stores/Api";
import { useSession } from "src/stores/Session";
import { useStore } from "src/stores/Store";
import colors from "src/utils/colors";
import { getOfferingCapacity } from "src/utils/getOfferingCapacity";
import message from "src/utils/message";
import { modals, useModal } from "src/utils/modals";
import tw from "src/utils/tw";
import { useMediaQueries } from "src/utils/useMediaQueries";
import {
  CapacityStatus,
  GroupRegistrationStatus,
  MembershipStatus,
  findClassItem,
  findClassItemVariables,
} from "types/code-generator";
import { TypedDocumentNode } from "types/graphql";
import { v4 as uuid } from "uuid";
import { BorderButton } from "../buttons/BorderButton";
import InputCheckbox from "../inputs/InputCheckbox";
import InputError from "../inputs/InputError";
import { InputText } from "../inputs/InputText";
import Modal from "./Modal";

interface Props {
  classItem?: ClassModel;
  semiPrivateRegistration?: GroupRegistrationModel;
  onAddToCart?: () => void;
  handleCancel?: () => void;
}

export const AddStudentToRegistrationModal = modals.create((props: Props) => {
  const store = useStore();
  const session = useSession();
  const form = useForm();
  const modal = useModal();
  const { small } = useMediaQueries();
  const [groupRegistrations, setGroupRegistrations] = useState([]);
  const [semiPrivateRegistration, setSemiPrivateRegistration] = useState(null);
  const [students, setStudents] = useState([]);
  const [error, setError] = useState(null);
  const [adding, setAdding] = useState(false);
  const classItem = new ClassModel(props.classItem);
  const membersOnly = props.classItem.allowNonMembers === false;
  let userMemberships = store.user?.memberships || [];

  if (store.user?.primaryAccount) {
    userMemberships = store.user.primaryAccount.memberships || [];
  }

  const memberships = [
    ...(userMemberships.filter((m) =>
      classItem.membershipOfferings.find(
        (mo) => m.status === MembershipStatus.Active && mo.id === m.offeringId
      )
    ) || []),
    ...(session.memberships?.filter((sm) =>
      classItem.membershipOfferings.find((mo) => mo.id === sm.offering.id)
    ) || []),
  ];
  const isMember = memberships.length > 0;

  useEffect(() => {
    if (modal.visible) {
      // if (props.semiPrivateRegistration) {
      //   setSemiPrivateRegistration(semiPrivateRegistration);
      // } else if (classItem?.semiPrivate) {
      //   setSemiPrivateRegistration(
      //     new GroupRegistrationModel({
      //       class: classItem,
      //       roster: [],
      //     })
      //   );
      // } else {
      //   setGroupRegistrations([
      //     ...session.groupRegistrations
      //       .slice()
      //       .filter((r) => r.class.id === classItem.id),
      //   ]);
      // }

      setGroupRegistrations([
        ...session.groupRegistrations
          .slice()
          .filter((r) => r.class.id === classItem.id),
      ]);

      // console.log("session", session);

      if (session.students.length === 0) {
        if (!small) {
          addNewStudent();
        }
      }
    }
  }, [modal.visible]);

  async function addToCart() {
    if (adding || !classItem) {
      return;
    }

    setAdding(true);
    setError(null);

    const processingMessage = message.loading("Adding…");

    const studentsWithoutNames = groupRegistrations.filter(
      (r) => r.student && r.student.firstName === ""
    );

    if (studentsWithoutNames.length > 0) {
      setError("Please enter a student name to continue");
      setAdding(false);
      processingMessage();
      return;
    }

    const registrationsWithNames = groupRegistrations.filter(
      (r) => r.student && r.student.firstName !== ""
    );

    const studentsWithNames = students.filter((s) => s.firstName !== "");
    const addedGroupRegistrations = [];

    studentsWithNames.forEach((s) => {
      if (!session.students.find((ss) => ss.firstName === s.firstName)) {
        session.setStudents((current) => {
          return [...current, s];
        });
      }
    });

    if (semiPrivateRegistration) {
      if (semiPrivateRegistration.roster.length === 0) {
        if (semiPrivateRegistration.id) {
          session.removeRegistration(semiPrivateRegistration.id);
        }

        processingMessage();

        setAdding(false);

        handleCancel();
        return;
      }

      session.addGroupRegistration(semiPrivateRegistration);

      processingMessage();

      setAdding(false);
      handleCancel();
      return;
    } else {
      session.groupRegistrations
        .filter((r) => r.class && classItem && r.class.id === classItem.id)
        .forEach((cr) => {
          const registrationIsActive = groupRegistrations.find(
            (r) => r.student && r.student.id === cr.student.id
          );
          if (!registrationIsActive) {
            session.removeRegistration(cr.id);
          }
        });
    }

    let classModel = new ClassModel(classItem);

    console.log("classItem", classItem);

    try {
      const fetchClassData = await apiClient(ClassQuery, {
        variables: {
          id: classItem.id,
        },
      });

      console.log("fetchClassData", fetchClassData);

      classModel = new ClassModel(fetchClassData.class);
    } catch (e) {
      console.log("e", e);
      return;
    }

    const newClassModel = new ClassModel({
      ...classModel,
      registrations: [
        ...classModel.registrations,
        ...session.groupRegistrations.filter(
          (gr) => gr.class.id === classItem.id
        ),
      ],
    });

    const waitlist = newClassModel.getWaitlist();

    // console.log("classModel", classModel);
    // console.log("registrationsWithNames", registrationsWithNames);
    // console.log("newClassModel.capacity", newClassModel.capacity);
    // console.log("newClassModel", newClassModel.getRoster());

    const newGroupRegistrations = [...session.groupRegistrations];

    for (const r of registrationsWithNames) {
      // console.log("r", r);
      // console.log("newClassModel.registrations", newClassModel.registrations);

      const alreadyInCart = newGroupRegistrations.findIndex((cr) => {
        return cr.class.id === r.class.id && cr.student.id === r.student.id;
        // if (classItem.semiPrivate) {
        //   const existingStudents = cr.roster.map((s) => s.id);
        //   return r.roster.every((rs) => existingStudents.includes(rs.id));
        // } else {
        //   return cr.class.id === r.class.id && cr.student.id === r.student.id;
        // }
      });

      const values = form.getFieldsValue();
      const customerInfoRequestResponses = [];

      for (const key in values) {
        if (key.includes("cirr-")) {
          const data = key.split(":");
          const answer = values[key];

          customerInfoRequestResponses.push({
            id: uuid(),
            answer,
            question: classItem.customerInfoRequests[data[1]],
          });
        } else if (key.includes("cirr")) {
          const data = key.split(":");
          const answer = values[key];

          customerInfoRequestResponses.push({
            id: uuid(),
            answer,
            question: data[1].replace("_UNSAFE_PERIOD_", "."),
          });
        }
      }

      console.log("r", r);

      if (alreadyInCart >= 0) {
        session.addGroupRegistration({
          ...r,
          customerInfoRequestResponses,
        });
      } else {
        const groupRegistration = new GroupRegistrationModel({
          ...r,
          id: uuid(),
          status: GroupRegistrationStatus.Pending,
          class: classModel,
          customerInfoRequestResponses,
        });

        const addToWaitlist =
          newClassModel.capacity === CapacityStatus.Waitlist ||
          (newClassModel.capacity === CapacityStatus.WaitlistAvailable &&
            waitlist.length > 0 &&
            waitlist.length < newClassModel.waitlistCapacity);

        const available =
          !addToWaitlist &&
          (newClassModel.capacity === CapacityStatus.Available ||
            newClassModel.capacity === CapacityStatus.WaitlistAvailable);

        console.log("addToWaitlist", addToWaitlist);

        if (available && !classModel.autoEnroll) {
          session.addGroupRegistration(groupRegistration);
          newClassModel.registrations.push(groupRegistration);
          addedGroupRegistrations.push(groupRegistration.id);
        } else if (available && classModel.autoEnroll) {
          groupRegistration.status = GroupRegistrationStatus.Approved;
          session.addGroupRegistration(groupRegistration);
          newClassModel.registrations.push(groupRegistration);
          addedGroupRegistrations.push(groupRegistration.id);
        } else if (addToWaitlist) {
          groupRegistration.status = GroupRegistrationStatus.Waitlist;
          session.addGroupRegistration(groupRegistration);
          newClassModel.registrations.push(groupRegistration);
          addedGroupRegistrations.push(groupRegistration.id);
        } else if (newClassModel.capacity === CapacityStatus.Full) {
          if (store.user?.isAdminOrAbove) {
            groupRegistration.status = GroupRegistrationStatus.Approved;
            session.addGroupRegistration(groupRegistration);
            newClassModel.registrations.push(groupRegistration);
            addedGroupRegistrations.push(groupRegistration.id);
          } else {
            processingMessage();
            setError(
              "The waitlist capacity will be exceeded. Please adjust your selections and try again."
            );
            setAdding(false);

            message.error(
              "The waitlist capacity will be exceeded. Please adjust your selections and try again."
            );

            for (const id of addedGroupRegistrations) {
              session.removeRegistration(id);
            }
          }
        }

        const newCapacity = getOfferingCapacity(newClassModel);
        newClassModel.capacity = newCapacity;
      }
    }

    if (error) {
      return;
    }

    setGroupRegistrations([]);
    setStudents([]);
    setAdding(false);

    processingMessage();

    if (props.onAddToCart) {
      props.onAddToCart();
    }

    handleCancel();
  }

  function afterClose() {
    setGroupRegistrations([]);
    setSemiPrivateRegistration(null);
    setStudents([]);
    setError(null);
    setAdding(false);
  }

  function addNewStudent() {
    const newStudent = {
      id: uuid(),
      firstName: `${classItem?.participantType} ${
        students.length + session.students.length + 1
      }`,
    };

    const registrationStatus = classItem.capacity;

    let status: GroupRegistrationStatus = GroupRegistrationStatus.Pending;

    if (registrationStatus === CapacityStatus.Waitlist) {
      status = GroupRegistrationStatus.Waitlist;
    } else if (
      registrationStatus === CapacityStatus.Available &&
      classItem.autoEnroll
    ) {
      status = GroupRegistrationStatus.Approved;
    }

    // console.log("status", status);

    let groupRegistration;
    const newStudents = [...students, newStudent];

    if (semiPrivateRegistration) {
      groupRegistration = new GroupRegistrationModel({
        ...semiPrivateRegistration,
        status,
      });

      groupRegistration.roster.push(newStudent);

      setSemiPrivateRegistration(groupRegistration);
      setStudents(newStudents);
    } else {
      groupRegistration = new GroupRegistrationModel({
        class: classItem,
        student: newStudent,
        status,
      });
      let newGroupRegistrations = [...groupRegistrations.slice()];
      newGroupRegistrations.push(groupRegistration);
      console.log("newGroupRegistrations", newGroupRegistrations);

      setGroupRegistrations(newGroupRegistrations);
      setStudents(newStudents);
    }
  }

  function toggleRegistration(checked, student) {
    const registrationStatus = classItem.capacity;

    let status: GroupRegistrationStatus = GroupRegistrationStatus.Pending;

    if (registrationStatus === CapacityStatus.Waitlist) {
      status = GroupRegistrationStatus.Waitlist;
    } else if (
      registrationStatus === CapacityStatus.Available &&
      classItem.autoEnroll
    ) {
      status = GroupRegistrationStatus.Approved;
    }

    if (semiPrivateRegistration) {
      const newSemiPrivateRegistration = new GroupRegistrationModel({
        ...semiPrivateRegistration,
        status,
      });

      if (checked) {
        newSemiPrivateRegistration.roster.push(student);
      } else {
        newSemiPrivateRegistration.roster =
          newSemiPrivateRegistration.roster.filter((s) => s.id !== student.id);
      }

      setSemiPrivateRegistration(newSemiPrivateRegistration);
      setError(null);

      return;
    }

    let newGroupRegistrations = [...groupRegistrations];

    let groupRegistration = new GroupRegistrationModel({
      id: uuid(),
      class: classItem,
      status,
      student,
    });

    if (checked) {
      newGroupRegistrations.push(groupRegistration);
    } else {
      newGroupRegistrations = newGroupRegistrations.filter(
        (r) => r.student.id !== student.id
      );
    }

    setGroupRegistrations(newGroupRegistrations);
    setError(null);
  }

  function setStudentName(firstName, studentId) {
    const newStudents = [...students];
    const newStudentIndex = newStudents.findIndex((s) => s.id === studentId);
    newStudents[newStudentIndex].firstName = firstName;

    setStudents(newStudents);
  }

  function showStudentsCheckboxes() {
    const content = [];

    if (!classItem) {
      return content;
    }

    const studentsAlreadyEnrolled = session.students.filter((s) => {
      if (
        classItem.registrations.find(
          (r) =>
            (r.student &&
              r.student.id === s.id &&
              r.status === GroupRegistrationStatus.Approved) ||
            (r.roster && r.roster.find((rs) => rs.id === s.id))
        )
      ) {
        return true;
      }
      return false;
    });

    const studentsPendingApproval = session.students.filter((s) => {
      if (
        classItem.registrations.find(
          (r) =>
            r.student &&
            r.student.id === s.id &&
            r.status === GroupRegistrationStatus.Pending
        )
      ) {
        return true;
      }
      return false;
    });

    const studentsWaitlisted = session.students.filter((s) => {
      if (
        classItem.registrations.find(
          (r) =>
            r.student &&
            r.student.id === s.id &&
            r.status === GroupRegistrationStatus.Waitlist
        )
      ) {
        return true;
      }
      return false;
    });

    studentsAlreadyEnrolled.forEach((s) => {
      content.push(
        <React.Fragment key={`${s.id}-enrolled`}>
          <div className="flex items-center">
            <InputCheckbox checked disabled className="mr-4" />
            <div className="flex flex-1 items-center">
              <div className="flex-1">{s.firstName}</div>
              <div>
                <i aria-hidden className="far fa-bolt-lightning text-success" />{" "}
                <strong>Enrolled</strong>
              </div>
            </div>
          </div>
          <hr />
        </React.Fragment>
      );
    });

    studentsPendingApproval.forEach((s) => {
      content.push(
        <React.Fragment key={`${s.id}-pending`}>
          <div className="flex items-center">
            <InputCheckbox checked disabled className="mr-4" />
            <div className="flex flex-1 items-center">
              <div className="flex-1">{s.firstName}</div>
              <div>
                <i
                  aria-hidden
                  className="far fa-triangle-exclamation text-main"
                />{" "}
                <strong>Pending</strong>
              </div>
            </div>
          </div>
          <hr />
        </React.Fragment>
      );
    });

    studentsWaitlisted.forEach((s) => {
      content.push(
        <React.Fragment key={`${s.id}-pending`}>
          <div className="flex items-center">
            <InputCheckbox checked disabled className="mr-4" />
            <div className="flex flex-1 items-center">
              <div className="flex-1">{s.firstName}</div>
              <div>
                <i
                  aria-hidden
                  className="far fa-triangle-exclamation text-main"
                />{" "}
                <strong>Waitlist</strong>
              </div>
            </div>
          </div>
          <hr />
        </React.Fragment>
      );
    });

    session.students
      .filter((student) => {
        if (membersOnly && !isMember && !store.isAdminArea) {
          return userMemberships.find((m) =>
            m.roster.find((mr) => mr.id === student.id)
          );
        }

        return (
          !studentsAlreadyEnrolled.find((s) => s.id === student.id) &&
          !studentsPendingApproval.find((s) => s.id === student.id) &&
          !studentsWaitlisted.find((s) => s.id === student.id) &&
          !students.find((s) => s.id === student.id)
        );
      })
      .forEach((student) => {
        let registration = groupRegistrations.find(
          (r) =>
            r.class?.id === classItem.id &&
            r.student &&
            r.student.id === student.id
        );

        let participantIsMember = false;

        if (store.isAdminArea) {
          participantIsMember = Boolean(
            session.accountOwner?.memberships.find((m) =>
              m.roster.find((mr) => mr.id === student.id)
            )
          );
        } else {
          participantIsMember = memberships.some((m) =>
            m.roster.find((r) => r.id === student.id)
          );
        }

        if (semiPrivateRegistration) {
          registration = semiPrivateRegistration.roster.find(
            (rs) => rs.id === student.id
          );
        }

        content.push(
          <React.Fragment key={`${student.id}`}>
            <div className="flex items-center">
              <InputCheckbox
                checked={!!registration}
                onChange={(e) => toggleRegistration(e, student)}
                className="mr-4"
                disabled={
                  membersOnly
                    ? !store.isAdminArea && !participantIsMember
                    : false
                }
              />
              <div
                className={tw(
                  "flex-1",
                  membersOnly &&
                    !participantIsMember &&
                    !store.isAdminArea &&
                    "text-empty"
                )}
              >
                {student.firstName}{" "}
                {membersOnly && !participantIsMember && (
                  <div className="text-sm text-empty">
                    <i className="far fa-triangle-exclamation mr-1 text-main" />{" "}
                    Missing a required membership.
                  </div>
                )}
              </div>
            </div>
            <hr />
          </React.Fragment>
        );
      });

    students
      .filter((student) => {
        return true;
      })
      .forEach((student) => {
        let registration = groupRegistrations.find(
          (r) => r.class?.id === classItem.id && r.student?.id === student.id
        );

        if (semiPrivateRegistration) {
          registration = semiPrivateRegistration.roster.find(
            (rs) => rs.id === student.id
          );
        }

        const initialValue = student.firstName;
        let participantIsMember = false;

        if (store.isAdminArea) {
          participantIsMember = Boolean(
            session.accountOwner?.memberships.find((m) =>
              m.roster.find((mr) => mr.id === student.id)
            )
          );
        } else {
          participantIsMember = memberships.some((m) =>
            m.roster.find((r) => r.id === student.id)
          );
        }

        content.push(
          <React.Fragment key={student.id}>
            <div className="flex">
              <InputCheckbox
                checked={!!registration}
                onChange={(e) => toggleRegistration(e, student)}
              />
              <div className="flex-1">
                <div className="step-subhead relative z-10 -mb-1 pl-4 text-2xs">
                  First Name
                </div>
                <InputText
                  className="border-none bg-white"
                  placeholder={`Add ${classItem?.participantType} First Name`}
                  value={initialValue}
                  onChange={(name) => setStudentName(name, student.id)}
                  selectTextOnFocus={Boolean(student.firstName)}
                  autoFocus
                />
                {membersOnly && !participantIsMember && (
                  <div className="pl-4 text-sm text-empty">
                    <i className="far fa-triangle-exclamation mr-1 text-main" />{" "}
                    Missing a required membership.
                  </div>
                )}
              </div>
            </div>
            <hr />
          </React.Fragment>
        );
      });

    return content;
  }

  function handleCancel() {
    modal.hide();

    if (props.handleCancel) {
      props.handleCancel();
    }
  }

  const empty = groupRegistrations.length === 0 && !semiPrivateRegistration;
  const studentCheckboxes = showStudentsCheckboxes();

  return (
    <Modal
      visible={modal.visible}
      handleCancel={handleCancel}
      footer={
        <>
          <div className="flex-1">
            <BorderButton
              type="submit"
              onClick={addToCart}
              disabled={adding || empty}
              className="w-full"
            >
              Save
            </BorderButton>
          </div>
          <div className="flex-1">
            <BorderButton onClick={modal.hide} className="w-full">
              Cancel
            </BorderButton>
          </div>
        </>
      }
      title={`Add ${classItem?.participantType}`}
      afterClose={afterClose}
    >
      <p>
        Select or add {classItem?.participantType.toLowerCase()}s to this{" "}
        {classItem && classItem.type.toLowerCase()}.
      </p>
      <hr />
      {studentCheckboxes}

      <div className="mb-4">
        <InputError error={error} />
      </div>

      {(!membersOnly || (membersOnly && store.isAdminArea)) && (
        <BorderButton
          dashed
          className="w-full"
          onClick={addNewStudent}
          bgColor="#fff"
        >
          <div className="flex items-center">
            <i
              className="far fa-plus"
              css={{
                color: store.isAdminArea ? colors.action : store.theme.orgColor,
              }}
            />
            <div className="flex-1">
              Add {students.length > 0 && " another "}{" "}
              {classItem?.participantType.toLowerCase()}
            </div>
          </div>
        </BorderButton>
      )}

      {membersOnly && !store.isAdminArea && (
        <div className="pb-4 pt-2 text-sm text-empty">
          This {classItem.type.toLowerCase()} is available to select members.{" "}
          <LinkButton onClick={modal.hide} to={`/find/${classItem.id}`}>
            <strong>View details</strong>
          </LinkButton>
        </div>
      )}

      {membersOnly && store.isAdminArea && (
        <div className="pb-8 pt-4">
          This settings for this {classItem.type.toLowerCase()} require one of
          the following memberships. Admin may override this requirement.
          <div className="divide-y divide-borderGray">
            {classItem.membershipOfferings.map((m) => {
              return (
                <div key={m.id} className="py-2">
                  <i className="far fa-certificate mr-1 mt-1 text-organization" />
                  {m.program?.title}
                  {m.title && ` • ${m.title}`}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {classItem?.customerInfoRequests?.length > 0 && (
        <CustomerInfoRequestResponses offering={classItem} form={form} />
      )}
    </Modal>
  );
});

const ClassQuery = gql`
  query findClassItem($id: String!) {
    class(where: { id: $id }) {
      id
      additionalFeeAmount
      additionalFeeBillingCategory {
        id
        title
      }
      additionalFeeTitle
      addons {
        id
        title
        description
        billingCategory {
          id
          title
        }
        price
      }
      allowAdditionalStudents
      allowNonMembers
      applyAnnualFee
      attendedOnCheckIn
      autoEnroll
      agreements {
        id
        title
        description
        required
      }
      capacity
      chargeAmounts(where: { status: { not: Processed } }) {
        id
        atRegistration
        date
        price
        membershipOffering {
          id
          title
        }
      }
      charges {
        id
        amount
        appliesTo
        billingCategory {
          id
          title
        }
        description
      }
      chargeType
      checkIn
      classTimes {
        id
        date
        day
        endTime
        location {
          id
          title
        }
        startTime
        zone {
          id
          title
        }
      }
      collectTaxes
      coupons {
        id
        amount
        availableForAllOfferings
        code
        expirationDate
        frequency
        title
        amountType
      }
      createdAt
      credits {
        id
        amount
        billingCategory {
          id
          title
        }
        description
      }
      customerCheckIn
      customerInfoRequests
      department {
        id
        active
        annualFeeAmount
        annualFeeAtBeginningOfYear
        annualFeeBillingCategory {
          id
          title
        }
        annualFeeCanBeAppliedAtOfferingLevel
        annualFeeMax
        annualFeeType
        contactName
        default
        email
        phone
        title
      }
      description
      discounts {
        id
      }
      displayOpenSpots
      earlyCheckIn
      earlyCheckInType
      endDate
      entryLevel
      evaluationReminderFrequency
      excludedDates
      fees {
        id
        title
        amount
        amountType
      }
      freePresentation
      frequency
      hideDefaultStaff
      instructors {
        id
        email
        firstName
        lastName
        phone
      }
      integration
      location {
        id
        title
        address1
        city
        state
        zip
      }
      maxCheckIns
      maxEnrollment
      membershipOfferings {
        id
      }
      membershipPrices {
        id
        price
        membershipOfferingId
      }
      membershipCheckIns {
        id
        amount
        type
        membershipOfferingId
      }
      membershipCheckInPrices {
        id
        price
        membershipOfferingId
      }
      minAge
      minAgeType
      maintainWaitlist
      maxAge
      maxAgeType
      multiClassDiscount
      multiStudentDiscount
      noClassTimes
      organization {
        id
      }
      participantType
      paymentFrequency
      paymentReminderDays
      paymentRate
      price
      priceAdjustments {
        id
        date
        price
      }
      private
      program {
        id
        department {
          id
          title
        }
        title
        description
      }
      prorateInProgressClasses
      prorateStartEnd
      prorateExcludedDates
      publishDate
      publishOnWebsite
      registrationOpen
      registrationClose
      registrations {
        id
        status
        studentId
      }
      requiresRegistration
      requiresUSASwimming
      startDate
      status
      studentInfoRequests {
        answers
        createdAt
        description
        department {
          id
        }
        id
        noQuestion
        required
        singleResponse
        slug
        type
        yesQuestion
      }
      tags {
        id
        title
      }
      templates {
        id
      }
      title
      type
      unpublishDate
      updatedAt
      waitlistCapacity
      zone {
        id
        title
      }
    }
  }
` as TypedDocumentNode<findClassItem, findClassItemVariables>;
